(function () {
    try {
        function hideDefaultTitleBundleVariants() {
            var selectElements = document.querySelectorAll('.salepify-product-bundle__variant-select');
            
            selectElements.forEach(function (select) {
                if (select.options.length === 1) {
                    var optionText = select.options[0].text.trim().toLowerCase();
                    if (optionText === 'default title' || optionText === 'default') {
                        select.style.setProperty('display', 'none', 'important');
                    }
                }
            });
        }

        hideDefaultTitleBundleVariants();

        var observer = new MutationObserver(function (mutations) {
            hideDefaultTitleBundleVariants();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

    } catch (error) {
        console.error("Error running hideDefaultTitleBundleVariants:", error);
    }
})();
